// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumbs_root__UYwFK"};